import { Point } from "tm-shared/types";
import { isPointChains, isPointDistribution } from "tm-shared/utils";

export const getPointContractSourceIds = (point: Point) => {
    return [
        point.id,
        point.market.contragent?.id,
        point.market.building.address?.regionId,
        point.market.building.address?.areaId,
        isPointDistribution(point) && point.typeContext.storage?.id,
        isPointChains(point) && point.typeContext.networkId,
    ].filter((val): val is string => Boolean(val));
};
